export default `
fragment ParagraphVideoYoutube on ParagraphVideoYoutube {
  id
  uuid
  entityBundle
  title
  description {
    value
  }
  youtube_urls
}
`
